module.exports = __webpack_public_path__ + "static/img/a7070xgri_pop6.357ccde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/images/a7070xgri_pop6.jpg
// module id = 4qrw
// module chunks = 0